export const GET_USER = 'GET_USER';
export const UPDATE_USER_EMAIL = 'UPDATE_USER_EMAIL';
export const GET_USER_PARTNER_BALANCES = 'GET_USER_PARTNER_BALANCES';
